import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SFLendingPartnersComponent from "./component";

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

const mapStateToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SFLendingPartnersComponent);
